// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTCopyJobSchedulePolicy,
    RESTLinkHAL,
} from './';

/**
 * @export
 * @interface RESTCopyJob
 */
export interface RESTCopyJob {
    /**
     * Backup job ID.
     * @type {string}
     * @memberof RESTCopyJob
     */
    backupJobId?: string | null;
    /**
     * @type {RESTCopyJobSchedulePolicy}
     * @memberof RESTCopyJob
     */
    schedulePolicy?: RESTCopyJobSchedulePolicy;
    /**
     * Backup copy job ID.
     * @type {string}
     * @memberof RESTCopyJob
     */
    id?: string | null;
    /**
     * ID of the Microsoft 365 organization.
     * @type {string}
     * @memberof RESTCopyJob
     */
    organizationId?: string | null;
    /**
     * ID of one of the following object storage repositories: Azure Blob Storage Archive access tier, Amazon S3 Glacier Instant Retrieval, Amazon S3 Glacier Flexible Retrieval or Amazon S3 Glacier Deep Archive storage classes. 
     * @type {string}
     * @memberof RESTCopyJob
     */
    repositoryId?: string | null;
    /**
     * Name of the backup copy job.
     * @type {string}
     * @memberof RESTCopyJob
     */
    name?: string;
    /**
     * Date and time of the last run of the backup copy job.
     * @type {string}
     * @memberof RESTCopyJob
     */
    lastRun?: string | null;
    /**
     * Date and time of the next run of the backup copy job per schedule.
     * @type {string}
     * @memberof RESTCopyJob
     */
    nextRun?: string | null;
    /**
     * Date and time of the last successful run of the backup copy job.
     * @type {string}
     * @memberof RESTCopyJob
     */
    lastBackup?: string | null;
    /**
     * Defines whether the backup copy job is enabled.
     * @type {boolean}
     * @memberof RESTCopyJob
     */
    isEnabled?: boolean | null;
    /**
     * Latest status of the backup copy job.
     * @type {string}
     * @memberof RESTCopyJob
     */
    lastStatus?: RESTCopyJobLastStatusEnum;
    /**
     * Version number that Veeam Backup for Microsoft 365 assigns if the backup copy job was modified.
     * @type {number}
     * @memberof RESTCopyJob
     */
    eTag?: number;
    /**
     * @type {{ [key: string]: RESTLinkHAL; }}
     * @memberof RESTCopyJob
     */
    readonly _links?: { [key: string]: RESTLinkHAL; };
}

/**
 * @export
 * @enum {string}
 */
export enum RESTCopyJobLastStatusEnum {
    Stopped = 'Stopped',
    Running = 'Running',
    Success = 'Success',
    Failed = 'Failed',
    Warning = 'Warning',
    NotConfigured = 'NotConfigured',
    Disconnected = 'Disconnected',
    Queued = 'Queued'
}

